export enum CustomEventNames {
	OpenResumeDialog = 'open-resume-dialog',
	DialogCloseOrAccept = 'dialog-close-or-accept',
	LoadingDone = 'loading-done',
	StartQuestionnaire = 'start-questionnaire',
	SubmitForm = 'submit-form',
	OpenQuestion = 'open-question',
	ResumeLater = 'resume-later',
	OpenClarificationDialog = 'open-clarification-dialog',
	ShowEnterCodeDialog = 'show-enter-code-dialog',
	AnswerQuestion = 'answer-question',
	OpenErrorDialog = 'open-error-dialog',
	BlockQuestionaire = 'block-questionaire',
	UnblockQuestionaire = 'unblock-questionaire',
	OpenReport = 'open-report',
	ShowResultBtn = 'show-result-btn',
}
